import { useState, useEffect } from 'react';
import { studentAPI } from '../services/api';

export const useStudentDetail = (studentID) => {
  const [student, setStudent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchStudent = async () => {
      if (!studentID) return;

      try {
        setLoading(true);
        setError(null);
        const response = await studentAPI.getById(studentID);
        setStudent(response.data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchStudent();
  }, [studentID]);

  return {
    student,
    loading,
    error,
  };
};
